import { type Journal } from '@littlebird/sdk';

export enum JournalFilterType {
  SHOW_ALL = 'show_all',
  UNREAD_ONLY = 'unread_only',
}

export interface InsufficientContextEntry {
  type: 'insufficient-context';
  id: string;
  startDate: Date;
  endDate: Date;
  dayCount: number;
}

export type JournalOrGap = Journal | InsufficientContextEntry;

export const isInsufficientContextEntry = (
  item: JournalOrGap
): item is InsufficientContextEntry => {
  return 'type' in item && item.type === 'insufficient-context';
};
